import React from "react";
import PropTypes from "prop-types";
import Text from "../common/descriptorcontrols/StringField/text";
import ControlTemplate
    from "../common/descriptorcontrols/BaseControls/ControlTemplate";
import Button from "../common/descriptorcontrols/BaseControls/Button";

export default function ModalPrompt({ title, label, initialValue, callback }) {
    const [ value, setValue ] = React.useState(initialValue);

    const formRef = React.useRef(null);
    React.useLayoutEffect(() => {
        if (!formRef.current || !formRef.current.elements) return;
        for (const el of formRef.current.elements) {
            if (el.classList && el.classList.contains("focusable")) {
                el.focus && el.focus();
                break;
            }
        }
    }, []);

    function handleOk(e) {
        e && e.preventDefault();
        callback(value);
    }

    function handleCancel() {
        callback(null);
    }

    return <form
        ref={formRef}
        className="modal-prompt"
        action="#unbound"
        onSubmit={handleOk}
    >
        <header>
            <h4 className={"title"}>{title}</h4>
        </header>
        <div className={"loading-body"}>
            <fieldset style={{display: "flex", flexDirection: "column", gap: "1em"}}>
                <Text
                    descriptor={{
                        id: "value",
                        key: "value",
                        type: "string",
                        control: "text",
                        label,
                        disableBehaviour: "disable",
                        config: {},
                        required: true,
                    }}
                    value={value}
                    onCommitChange={(desc, val) => setValue(val)}
                    enabled
                />
                <ControlTemplate
                    descriptor={{
                        id: "modal-actions",
                        key: "actions",
                        type: "widget",
                        control: "button",
                        label: "",
                        disableBehaviour: "disable",
                        config: {},
                    }}
                >
                    <Button
                        label="OK"
                        onClick={handleOk}
                        className="btn btn-primary"
                        enabled
                    />
                    <Button
                        label="Cancel"
                        onClick={handleCancel}
                        className="btn btn-default"
                        enabled
                    />
                </ControlTemplate>
            </fieldset>
        </div>
    </form>;
}

ModalPrompt.propTypes = {
    title: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    initialValue: PropTypes.string.isRequired,
    callback: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/lib/over/ModalPrompt.js